import { useEffect, useState } from "react";
import { useNotification } from "../../../../../context/NotificationContext";
import { Card, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineItem from "components/TimelineItem";
import noteService from "../../../../../services/noteService";
import PropTypes from "prop-types";

const ListNote = (props) => {
    const { expedienteId, refreshNotes } = props;
    const { showNotification } = useNotification();
    const [listNotes, setListNotes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                const data = await noteService.getNotebyExpedienteId(expedienteId);
                setListNotes(data);
            } catch (error) {
                showNotification("Error al cargar las notas", "error");
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [expedienteId, refreshNotes]);

    if (loading) {
        return (
            <MDBox display="flex" justifyContent="center" p={2}>
                <CircularProgress size={24} color="info" />
            </MDBox>
        );
    }

    return (
        <>
            {listNotes.length > 0 ? (
                <Card>
                    <MDBox p={2}>
                        {listNotes.map((item) => (
                            <TimelineItem
                                key={item.id}
                                color="info"
                                icon="sticky_note_2"
                                dateTime={item.fecha_creacion}
                                title={item.title}
                                description={item.description}
                                lastItem={item === listNotes.at(-1) && true}
                            />
                        ))}
                    </MDBox>
                </Card>
            ) : (
                <MDTypography variant="h6" color="text">
                    No hay información disponible.
                </MDTypography>
            )}
        </>
    );
};

ListNote.propTypes = {
    expedienteId: PropTypes.number.isRequired,
    refreshNotes: PropTypes.bool,
};

export default ListNote;
